<script setup lang="ts">
import { useTranslation } from "i18next-vue";
import { SaveState, SaveType } from "@/stores/SaveDrawingState";
import CanvasBusyOverlay from "./CanvasBusyOverlay.vue";

const { t } = useTranslation();
</script>

<template>
  <Teleport to="body">
    <CanvasBusyOverlay
      v-if="SaveState === 'saving'"
      :status="
        SaveType === 'auto'
          ? t('canvas:save.autoSaving')
          : t('canvas:save.saving')
      "
    />
  </Teleport>
</template>
